export default "__VITE_ASSET__C8ng417$__"